export const POOLS_ROUTE = "/pools"
export const EXCHANGER_ROUTE = "/exchanger"
export const PRESALE_ROUTE = "/presale"
export const ACCOUNT_ROUTE = "/account"
export const PROFILE_ROUTE = "/profile"
export const PRESALE_EXCHANGE_ROUTE = "/presale/exchange"
export const PRESALE_EXCHANGE_DONE_ROUTE = "/presale/exchange/done"
export const PRESALE_PURCHASE_ROUTE = "/presale/purchase/id/:id";
export const REGISTER_ROUTE_WITH_REF = "/account/register";
export const CREDITS_ROUTE = "/credits";
export const ACCOUNT_RESET_PASSWORD_ROUTE = "/account/reset-password";